import { getFullName } from '@/lib/user'
import revsCommon from './revsCommon'

export default {
  ...revsCommon,
  problem: item => item?.beforePhase?.situation,
  action: item => item?.afterPhase?.solution,
  problemSolver: item => getFullName(item?.completedBy),
}
